import axios from "axios";
import { getAPIUrl } from "../config";
import { headerConfig } from "./authConfig";
import { clearLocalStorage } from "./userStorage";

const serviceEndPoint = `${getAPIUrl()}/api/server`;

const handleApiError = (error, showToast) => {
  const status = error.response?.status || "Network Error";
  const message = error.response?.data?.message || error.message;

  if (showToast) {
    showToast(message, "error");
  }
  if (status === 401) {
    setTimeout(() => {
      clearLocalStorage();
    }, 500);
  }

  return { status, message };
};

export const getServers = async (showToast) => {
  try {
    const result = await axios.get(serviceEndPoint, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const getServerById = async (id, showToast) => {
  try {
    const result = await axios.get(`${serviceEndPoint}/${id}`, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const addServer = async (serverData, showToast) => {
  try {
    const result = await axios.post(serviceEndPoint, serverData, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const updateServer = async (serverData, showToast) => {
  try {
    const result = await axios.put(serviceEndPoint, serverData, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const deleteServer = async (id, showToast) => {
  try {
    const result = await axios.delete(`${serviceEndPoint}/${id}`, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const getServerMemory = async (showToast) => {
  try {
    const result = await axios.get(`${serviceEndPoint}/memory`, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const dropServerCaches = async (id, showToast) => {
  try {
    const result = await axios.post(`${serviceEndPoint}/${id}/drop-caches`, {}, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};
